<template>
  <div class="list-buttons">
    <button
      @click="editor.chain().focus().toggleBulletList().run()"
      :class="{ 'is-active': editor.isActive('bulletList') }"
      title="Bullet List"
    >
      <img
        width="20"
        src="/images/tiptap-bar/bullet-list.svg"
        alt="Bullet List"
      />
    </button>
    <button
      @click="editor.chain().focus().toggleOrderedList().run()"
      :class="{ 'is-active': editor.isActive('orderedList') }"
      title="Ordered List"
    >
      <img
        width="25"
        src="/images/tiptap-bar/ordered-list.svg"
        alt="Ordered List"
      />
    </button>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  editor: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.list-buttons {
  display: flex;
  gap: 10px;
}
</style>
